import script from "./PurchaseList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PurchaseList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__